module.exports = __webpack_public_path__ + "img/active-1.fb58ffc9.png";